<template >
    <div @click="$emit('click')" class="_wrapper">
        <!--  Pause  -->
        <span ref="pause" class="_icon _pause">
             <font-awesome-icon icon="pause" />
        </span>

        <!--  Play  -->
        <span ref="play" class="_icon">
          <font-awesome-icon icon="play" />
        </span>
    </div>
</template>

<script>
    export default {
        name: 'PlayToggleIcon',
        props:{
            playing:{
                type: Boolean,
                required: true
            }
        },

        computed:{
            playIcon(){
                return this.$refs.play;
            },
            pauseIcon(){
                return this.$refs.pause;
            }
        },

        watch:{
            playing(newVal){
                if(newVal){
                    this.isPlaying();
                }else {
                    this.isPaused();
                }
            }
        },

        methods:{
            isPlaying(){
                this
                    .$anime
                    .timeline({
                        easing: 'easeOutExpo',
                        duration: 1200
                    })
                    .add({
                        targets: this.playIcon,
                        translateY: 15,
                        opacity: 0
                    }, 0)
                    .add({
                        targets: this.pauseIcon,
                        translateY: 0,
                        opacity:1
                    }, 0);
            },
            isPaused(){
                this
                    .$anime
                    .timeline({
                        easing: 'easeOutExpo',
                        duration: 1200
                    }, 0)
                    .add({
                        targets: this.pauseIcon,
                        translateY: 15,
                        opacity: 0
                    })
                    .add({
                        targets: this.playIcon,
                        translateY: 0,
                        opacity:1
                    }, 0);
            }
        },
    }
</script>

<style>
    ._wrapper {
        width: 100%;
        height: auto;
        position: relative;
        cursor: pointer;
    }
    .cls-1{fill:#fff;}
    .st0{fill:#FFFFFF;}
    ._icon {
        position: absolute;
        top: 0;
        left: 0;
        cursor: pointer;
    }
    ._pause {
        opacity: 0;
    }
</style>